/* ============================================================
   1019 — Shopify theme front-end
   AJAX cart drawer, variant selection, index view toggle.
   ============================================================ */
(function () {
  "use strict";

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = window.moneyFormat || "${{amount}}";
    var amount = (cents / 100).toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    var amountNoDec = Math.round(cents / 100).toLocaleString("de-DE");
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount);
  }

  /* ============================================================
     CART
     ============================================================ */
  var Cart = {
    drawer: null,
    overlay: null,

    init: function () {
      this.drawer = document.querySelector("[data-cart-drawer]");
      this.overlay = document.querySelector("[data-cart-overlay]");
      if (!this.drawer) return;

      var self = this;
      document.querySelectorAll("[data-cart-toggle]").forEach(function (el) {
        el.addEventListener("click", function (e) {
          e.preventDefault();
          self.open();
        });
      });
      var closeBtn = this.drawer.querySelector("[data-cart-close]");
      if (closeBtn) closeBtn.addEventListener("click", function () { self.close(); });
      if (this.overlay) this.overlay.addEventListener("click", function () { self.close(); });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") self.close();
      });

      this.refresh();
    },

    open: function () {
      this.drawer.classList.add("open");
      this.drawer.setAttribute("aria-hidden", "false");
      if (this.overlay) this.overlay.hidden = false;
    },
    close: function () {
      this.drawer.classList.remove("open");
      this.drawer.setAttribute("aria-hidden", "true");
      if (this.overlay) this.overlay.hidden = true;
    },

    add: function (variantId, qty) {
      var self = this;
      return fetch(window.routes.cart_add_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }),
      })
        .then(function (r) { return r.json(); })
        .then(function () { return self.refresh(); })
        .then(function () { self.open(); });
    },

    changeLine: function (line, qty) {
      var self = this;
      return fetch(window.routes.cart_change_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: qty }),
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); });
    },

    refresh: function () {
      var self = this;
      return fetch(window.routes.cart_url + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },

    render: function (cart) {
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = cart.item_count;
      });
      var total = document.querySelector("[data-cart-total]");
      if (total) total.textContent = formatMoney(cart.total_price);

      var box = this.drawer.querySelector("[data-cart-items]");
      if (!box) return;
      if (!cart.items.length) {
        box.innerHTML = '<p class="empty">Your cart is empty</p>';
        return;
      }
      var self = this;
      box.innerHTML = cart.items
        .map(function (item, i) {
          var img = item.image
            ? '<img src="' + item.image + '" alt="">'
            : '<div class="ph"></div>';
          var opts = item.options_with_values
            ? item.options_with_values
                .map(function (o) { return o.value; })
                .filter(function (v) { return v && v !== "Default Title"; })
                .join(" / ")
            : "";
          var sub = (opts ? opts + " — " : "") + item.quantity + "×";
          return (
            '<div class="cart-item">' +
            '<div class="media">' + img + "</div>" +
            '<div class="meta"><div>' + item.product_title + "</div>" +
            '<div class="sub">' + sub + "</div></div>" +
            "<div><div>" + formatMoney(item.final_line_price) + "</div>" +
            '<button class="rm" data-line="' + (i + 1) + '">Remove</button></div>' +
            "</div>"
          );
        })
        .join("");

      box.querySelectorAll("[data-line]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          self.changeLine(parseInt(btn.dataset.line, 10), 0);
        });
      });
    },
  };

  /* ============================================================
     PRODUCT (variant selection + AJAX add)
     ============================================================ */
  var Product = {
    init: function () {
      var root = document.querySelector("[data-product]");
      if (!root) return;
      this.root = root;

      var json = document.querySelector("[data-variants-json]");
      this.variants = json ? JSON.parse(json.textContent) : [];

      this.form = root.querySelector("#product-form");
      this.idInput = root.querySelector("[data-variant-id]");
      this.addBtn = root.querySelector("[data-add]");
      this.addLabel = root.querySelector("[data-add-label]");
      this.addPrice = root.querySelector("[data-add-price]");

      // selected option values, ordered by option index
      this.selected = [];

      var self = this;
      root.querySelectorAll(".opt-btn").forEach(function (btn) {
        var idx = parseInt(btn.dataset.optionIndex, 10);
        if (btn.classList.contains("active")) self.selected[idx] = btn.dataset.value;
        btn.addEventListener("click", function () {
          if (btn.disabled) return;
          root
            .querySelectorAll('.opt-btn[data-option-index="' + idx + '"]')
            .forEach(function (b) { b.classList.remove("active"); });
          btn.classList.add("active");
          self.selected[idx] = btn.dataset.value;
          var label = root.querySelector('[data-option-label="' + idx + '"]');
          if (label) label.textContent = btn.dataset.value;
          self.update();
        });
      });

      this.initGallery();

      if (this.form) {
        this.form.addEventListener("submit", function (e) {
          e.preventDefault();
          var id = self.idInput.value;
          if (!id || self.addBtn.disabled) return;
          if (self.addLabel) self.addLabel.textContent = "Adding…";
          Cart.add(id, 1).then(function () {
            if (self.addLabel) self.addLabel.textContent = Product.labelFor(self.currentVariant());
          });
        });
      }

      this.update();
    },

    currentVariant: function () {
      // Single-variant products render no option buttons — the one
      // variant IS the selection (fixes false "Unavailable").
      if (this.variants.length === 1) return this.variants[0];
      var sel = this.selected;
      return this.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    },

    // Strike through / disable option values that lead to an unavailable
    // variant, given the other currently selected option values.
    refreshOptionAvailability: function () {
      var self = this;
      this.root.querySelectorAll(".opt-btn").forEach(function (btn) {
        var idx = parseInt(btn.dataset.optionIndex, 10);
        var anyAvailable = self.variants.some(function (v) {
          if (!v.available) return false;
          return v.options.every(function (opt, j) {
            if (j === idx) return opt === btn.dataset.value;
            return self.selected[j] === undefined || opt === self.selected[j];
          });
        });
        btn.disabled = !anyAvailable;
        btn.classList.toggle("sold", !anyAvailable);
      });
    },

    labelFor: function (v) {
      if (!v) return "Unavailable";
      return v.available ? "Add to cart" : "Sold out";
    },

    update: function () {
      this.refreshOptionAvailability();
      var v = this.currentVariant();
      if (!v) {
        this.addBtn.disabled = true;
        if (this.addLabel) this.addLabel.textContent = "Unavailable";
        return;
      }
      this.idInput.value = v.id;
      this.addBtn.disabled = !v.available;
      if (this.addLabel) this.addLabel.textContent = this.labelFor(v);
      if (this.addPrice) this.addPrice.textContent = v.price_html;

      // reflect in URL
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        history.replaceState({}, "", url);
      }
    },

    initGallery: function () {
      var main = this.root.querySelector("[data-main-media]");
      if (!main) return;
      this.root.querySelectorAll("[data-thumb]").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var full = thumb.dataset.full;
          var img = main.querySelector("img");
          if (img && full) {
            // srcset wins over src — strip it, or the image never swaps
            img.removeAttribute("srcset");
            img.removeAttribute("sizes");
            img.src = full;
          } else if (full) {
            var ph = main.querySelector(".ph");
            if (ph) ph.outerHTML = '<img src="' + full + '" alt="">';
          }
          thumb.parentNode.querySelectorAll("[data-thumb]").forEach(function (t) {
            t.classList.remove("active");
          });
          thumb.classList.add("active");
        });
      });
    },
  };

  /* ============================================================
     GRID density toggle ( + )
     Desktop: 6 ↔ 3 columns. Mobile: 3 → 2 → 1 (tap to cycle).
     ============================================================ */
  function initGridToggle() {
    var grid = document.querySelector("[data-grid]");
    var btn = document.querySelector("[data-grid-toggle]");
    if (!grid || !btn) return;

    var KEY = "1019_cols";

    function cycle() {
      if (window.matchMedia("(max-width: 700px)").matches) return [3, 2, 1];
      if (window.matchMedia("(max-width: 1000px)").matches) return [4, 2];
      return [6, 3];
    }
    function current() {
      return parseInt(getComputedStyle(grid).getPropertyValue("--cols"), 10) || cycle()[0];
    }
    function apply(n) { grid.style.setProperty("--cols", n); }

    try {
      var saved = parseInt(localStorage.getItem(KEY), 10);
      if (saved > 0) apply(saved);
    } catch (e) {}

    btn.addEventListener("click", function () {
      var arr = cycle();
      var idx = arr.indexOf(current());
      var next = arr[(idx + 1) % arr.length];
      apply(next);
      try { localStorage.setItem(KEY, next); } catch (e) {}
    });

    // reset to a sensible default for the new breakpoint on resize
    var lastMobile = window.matchMedia("(max-width: 700px)").matches;
    window.addEventListener("resize", function () {
      var nowMobile = window.matchMedia("(max-width: 700px)").matches;
      if (nowMobile !== lastMobile) {
        lastMobile = nowMobile;
        grid.style.removeProperty("--cols");
        try { localStorage.removeItem(KEY); } catch (e) {}
      }
    });
  }

  /* ---------- boot ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    Cart.init();
    Product.init();
    initGridToggle();
  });
})();
